<script setup lang="ts">
import { EVENTS_ROUTES } from '@/router/routes'
import type { DetectionModel } from '@/types/models/DetectionModel'
import { ClickableTypography } from '@rfc/rfc-components-library'

type Props = DetectionModel
defineProps<Props>()
</script>

<template>
    <ClickableTypography :label="event_name" :href="EVENTS_ROUTES.buildUrl(event_id as number)" />
</template>
